/* eslint-disable import/prefer-default-export */
export const useTruncateStyle = () => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
